var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitData.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "p-8 sm:p-6" },
        [
          _c(
            "sw-input-group",
            {
              attrs: {
                label: _vm.$t("document_types.name"),
                error: _vm.nameError,
                variant: "horizontal",
                required: "",
              },
            },
            [
              _c("sw-input", {
                ref: "name",
                attrs: { invalid: _vm.$v.formData.name.$error, type: "text" },
                on: {
                  input: function ($event) {
                    return _vm.$v.formData.name.$touch()
                  },
                },
                model: {
                  value: _vm.formData.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              staticClass: "mt-5",
              attrs: {
                label: _vm.$t("document_types.validity") + " en jours",
                error: _vm.validityError,
                variant: "horizontal",
              },
            },
            [
              _c("sw-input", {
                ref: "validity",
                attrs: {
                  invalid: _vm.$v.formData.validity.$error,
                  type: "text",
                },
                on: {
                  input: function ($event) {
                    return _vm.$v.formData.validity.$touch()
                  },
                },
                model: {
                  value: _vm.formData.validity,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "validity", $$v)
                  },
                  expression: "formData.validity",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "z-0 flex justify-end p-4 border-t border-gray-200 border-solid border-modal-bg",
        },
        [
          _c(
            "sw-button",
            {
              staticClass: "mr-3 text-sm",
              attrs: { type: "button", variant: "primary-outline" },
              on: { click: _vm.closeDocumentTypeModal },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("general.cancel")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "sw-button",
            {
              attrs: {
                variant: "primary",
                type: "submit",
                loading: _vm.isLoading,
              },
            },
            [
              !_vm.isLoading
                ? _c("save-icon", { staticClass: "mr-2" })
                : _vm._e(),
              _vm._v(
                "\n      " +
                  _vm._s(
                    !_vm.isEdit
                      ? _vm.$t("general.save")
                      : _vm.$t("general.update")
                  ) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }